module.exports = __webpack_public_path__ + "static/img/starvan.063964c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/starvan.png
// module id = lx29
// module chunks = 1